import React from "react";
import { Modal, Button } from "react-bootstrap";

const ModalPC = ({ show, onClose, project }) => {

    let closeButton;

    if(window.innerWidth >= 1024 && window.innerWidth < 1440){
        closeButton = "200px"
    } else if (window.innerWidth >= 1440){
        closeButton = "120px"
    }

    let buttonBottom;

    if(window.innerWidth >= 1024 && window.innerWidth < 1440){
        buttonBottom = "200px"
    } else if (window.innerWidth >= 1440){
        buttonBottom = "170px"
    }

    const handleRequestBudget = () => {
        // Cerrar el modal
        onClose();
    
        // Desplazarse hacia el final de la página
        window.scrollTo({
          top: document.body.scrollHeight - 1250,
          behavior: "smooth"
        });
      };


  return (
    <Modal
      show={show}
      onHide={onClose}
      centered
      size="xl"
      style={{
        width: "100%",
        maxWidth: "1200px",
        margin: "auto",
        left: "50%",
        transform: "translate(-50%, -15%)", // Mueve el modal más arriba
        display: "flex",
        justifyContent: "center",
        overflow: "hidden"
      }}
    >
      <Modal.Dialog
        style={{
          overflow: "hidden", // Oculta cualquier scroll dentro del modal
        }}
      >
        <Modal.Body
          className="text-center"
          style={{
            padding: 0,
            position: "relative",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            overflow: "hidden", // Oculta scroll dentro del body
          }}
        >
          {/* Imagen Grande */}
          <img
            src={project.image.pc}
            alt={project.title}
            style={{
              width: "100%",
              maxWidth: "1200px",
              maxHeight: "80vh",
              objectFit: "contain",
              borderRadius: "10px",
            }}
          />

          {/* Botón sobre la imagen con altura dinámica */}
          <Button
            onClick={handleRequestBudget}
            style={{
              position: "absolute",
              bottom: buttonBottom,
              backgroundColor: "#000",
              border: "none",
              borderRadius: "5px",
              padding: "10px 50px",
              fontSize: "16px",
              color: "#fff",
              zIndex: 10,
            }}
          >
            Solicitar Presupuesto
          </Button>

          <Button
            onClick={onClose}
            style={{
              position: "absolute",
              top: closeButton,
              right : "10px",
              backgroundColor: "#000",
              border: "none",
              borderRadius: "5px",
              padding: "10px 10px",
              fontSize: "16px",
              color: "#fff",
              zIndex: 10,
            }}
          >
            X
          </Button>
        </Modal.Body>
      </Modal.Dialog>
    </Modal>
  );
};

export default ModalPC;
